import { useState } from 'react';

interface InvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  order: any;
}

export default function InvoiceModal({ isOpen, onClose, order }: InvoiceModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">인보이스</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">INVOICE</h3>
            <p className="text-gray-600">인보이스 번호: {order?.invoiceNumber || 'INV-2024-001'}</p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-gray-900 mb-2">발신</h4>
              <div className="text-sm text-gray-700 space-y-1">
                <p>업체명: {order?.vendor}</p>
                <p>담당자: {order?.manager}</p>
                <p>연락처: {order?.phone}</p>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-2">수신</h4>
              <div className="text-sm text-gray-700 space-y-1">
                <p>업체명: 체리쉬웨딩</p>
                <p>담당자: {order?.customer}</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 mb-3">상품 내역</h4>
            <table className="w-full border-collapse border border-gray-300">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-4 py-2 text-left text-sm">품목</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">수량</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">단가</th>
                  <th className="border border-gray-300 px-4 py-2 text-right text-sm">금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-sm">{order?.service}</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm">1</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm">{order?.amount}</td>
                  <td className="border border-gray-300 px-4 py-2 text-right text-sm font-medium">{order?.amount}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bg-blue-50 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <span className="text-lg font-semibold text-gray-900">총 금액</span>
              <span className="text-2xl font-bold text-blue-600">{order?.amount}</span>
            </div>
          </div>
        </div>

        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
          <button 
            onClick={onClose}
            className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            닫기
          </button>
          <button 
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-line mr-2"></i>
            다운로드
          </button>
        </div>
      </div>
    </div>
  );
}
